module.exports = {"623025100":"尼玛镇","623025200":"欧拉乡","623025201":"欧拉秀玛乡","623025202":"阿万仓乡","623025203":"木西合乡","623025204":"齐哈玛乡","623025205":"采日玛乡","623025206":"曼日玛乡","623025400":"河曲马场","623025401":"大水军牧场","623025402":"高原生物研究所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/623025.json
// module id = 2763
// module chunks = 0